import classNames from 'classnames'

import arrow from 'assets/img/admin/right-arrows.png'
import s from './AdminElemVisibilityToggle..module.scss'

type AdminElemVisibilityToggleProps = {
  text: string
  fontSize?: number
  className?: string
  isVisible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
}
export const AdminElemVisibilityToggle = ({
  text,
  fontSize = 14,
  className,
  isVisible,
  setVisible,
}: AdminElemVisibilityToggleProps) => {
  const classes = classNames(s.slidesTitleWrap, className)

  return (
    <div className={classes} onClick={() => setVisible(!isVisible)}>
      <h5 style={{ fontSize }}>{text}</h5>
      <img className={[s.arrowImg, isVisible && s.arrowImgBottom].join(' ')} src={arrow} alt="arrow" />
    </div>
  )
}
